import { render, staticRenderFns } from "./BaseDropDown.vue?vue&type=template&id=3c585eec&scoped=true"
import script from "./BaseDropDown.vue?vue&type=script&lang=js"
export * from "./BaseDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c585eec",
  null
  
)

export default component.exports